export default class EventCtrl {
    constructor($scope, $state, $stateParams, $rootScope, $timeout, Event, SideMenu) {
        SideMenu.setActive('event');

        this._state = $state;
        this._scope = $scope;
        this._timeout = $timeout;
        this._rootScope = $rootScope;

        this.eventRepo = Event;

        this.currentPage = 1;
        this.status = $stateParams.folder || 'draft';
        this.searchTimeout = false;

        this.eventRepo.statusCounts().then((counts)  => {
            this.statusCount = counts;
        });

        this._scope.$watch(() => this.currentPage, (newVal) => {
            if (newVal) {
                this.getPage();
            }
        });

        this._scope.$on('event:removed', () => {
            this.getPage();

            this.eventRepo.statusCounts().then((counts) => {
                this.statusCount = counts;
            });
        });

        this._rootScope.$on('event:newEventCreated', (event, data) => {
            this.events.unshift(data);

            this._timeout(() => {
                this.newEventFlash(19);
                $('.automation').first().find('.automation-name-input').first().focus(); // Focus name input
            });
        });
    }
    
    getPage() {
        this.loading = true;
        this.events = [];

        this.eventRepo.allByStatus(this.status, this.currentPage).then((response) => {
            this.events = response.data;
            this.metaData = response.meta['pagination'];
            this.loading = false;
        });
    };

    setStatus(status) {
        this._state.go('event.folder', { folder: status });
    };

    searchByStatus() {
        this.currentPage = 1;

        if (this.searchTimeout) {
            this._timeout.cancel(this.searchTimeout);
        }

        this.searchTimeout = this._timeout(() => {
            this.loading = true;
            this.events = [];

            this.eventRepo.searchByStatus(this.status, this.search).then((results) => {
                this.events = results.data;
                this.loading = false;
                this.metaData.total = this.metaData.per_page = 1;
            });
        }, 500);
    };

    clearSearch() {
        this.search = "";
        this.events = [];
        this.currentPage = 1;
        this.getPage();
    };

    newEventFlash(numIterations) {
        this._timeout(() => {
            $('.automation').first().toggleClass('green-border');

            if (numIterations > 0) {
                this.newEventFlash(numIterations - 1);
            }
        }, 500);
    };
}
